module.exports = __webpack_public_path__ + "img/雄黄.7a758e2f.jpg";